import { IGasStationInfo, VehicleFuelType } from '~/shared';

import { createSlice } from '../wrappers';

const initialState = {
	tabColors: ['#FFB800', '#00DBA6', '#E00000', '#BD00FF'],
	selectedType: null as VehicleFuelType | null,
	info: null as IGasStationInfo | null,
};

const gasStationSlice = createSlice({
	name: 'gasStation',
	initialState,
	reducers: {
		setSelectedType: (state, action) => {
			state.selectedType = action.payload;
		},
		setInfo: (state, action) => {
			state.info = action.payload;
		},
	},
});

export const { setSelectedType, setInfo } = gasStationSlice.actions;

export default gasStationSlice.reducer;
